import React from "react";
import classNames from "classnames";

import {API} from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import {Card, CardContent} from "@material-ui/core";

export default class Ip_Whitelist extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Admins_Securities._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	render() {
		const {data, pages, limit, loading} = this.state;

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Ip Whitelist')}
								<div className="ml-auto refresh">
									<Button color="secondary" onClick={this.reloadTable}><i
										className={"fa fa-refresh"}/></Button>
								</div>
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={[
								{
									Header: "IP",
									id: "ip_address",
									/** @param {Admins_Securities_Object} obj */
									accessor: obj => obj.ip_address,
								},
								{
									Header: "Date",
									id: "date",
									/** @param {Admins_Securities_Object} obj */
									accessor: obj => obj.date,
								},
								{
									Header: "",
									className: "button-cell",
									filterable: false,
									sortable: false,
									width: 40,
									Cell: props => {
										return (
											<span>
												<Link to={"/users/" + props.original.pkey}>
													<Button color="danger" size={"sm"} block={true}>
														<i className={"fa fa-trash"}/>
													</Button>
												</Link>
											</span>
										);
									}
								},
							]}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={pages > 1}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}